import { forwardRef, ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface GoldButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'solid' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

export const GoldButton = forwardRef<HTMLButtonElement, GoldButtonProps>(
  ({ children, variant = 'solid', size = 'md', className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'group relative inline-flex items-center justify-center overflow-hidden rounded-full border font-cinzel uppercase transition-all duration-500',
          'tracking-[0.24em] backdrop-blur-md',
          'before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-foreground/10 before:to-transparent before:translate-x-[-140%] before:transition-transform before:duration-700 hover:before:translate-x-[140%]',
          variant === 'solid' &&
            'bg-gradient-gold border-primary/30 text-primary-foreground shadow-ethereal hover:shadow-gold hover:-translate-y-0.5',
          variant === 'outline' &&
            'border-primary/35 bg-card/40 text-foreground hover:border-primary hover:bg-primary/14 hover:text-foreground',
          size === 'sm' && 'px-5 py-2.5 text-[10px]',
          size === 'md' && 'px-7 py-3.5 text-[11px]',
          size === 'lg' && 'px-8 py-4 text-[11px]',
          className
        )}
        {...props}
      >
        <span className="relative z-[1]">{children}</span>
      </button>
    );
  }
);

GoldButton.displayName = 'GoldButton';
